import React from 'react';
import { Navigate } from 'react-router-dom';
import routes from '../../config/routes';

const Fallback = () => <Navigate to={routes.home} />;

export default Fallback;
